export default "__VITE_ASSET__DUF17cJ6__"